import { service, BASE_API } from '@/utils/request'

export default {
  // 获取列表数据
  getCaseList: params => {
    return service({
      url: '/cloud/activity/caseCollection202411/pages',
      method: 'get',
      params
    })
  },
  // 上下架
  changeState: data => {
    return service({
      url: '/cloud/activity/caseCollection202411/changeState?'+data,
      method: 'post'
  
    })
  },
  getDetails: params => {
    return service({
      url: '/cloud/activity/caseCollection202411/details',
      method: 'get',
      params
    })
  },
  saveCase: data => {
    return service({
      url: '/cloud/activity/caseCollection202411/save',
      method: 'post',
      data
    })
  },
  auditCase: data => {
    return service({
      url: '/cloud/activity/caseCollection202411/check?' +data,
      method: 'post'
    })
  },

}



// WEBPACK FOOTER //
// ./src/api/operateManage/caseshow.js